import * as React from "react";
import styles from './Remove.module.scss'

interface MyIconProps {
    variant?: 'primary' | 'secondary' | 'inherit'
}

function Remove({ variant = 'inherit', ...props }: React.SVGProps<SVGSVGElement> & MyIconProps) {
    return (
        <div className={variant !== 'inherit' ? styles.circle : undefined}>
            <svg className={styles[variant || 'inherit']} xmlns="http://www.w3.org/2000/svg" width="18" height="20"
                viewBox="0 0 18 20" fill="none" {...props}>
                <path
                    d="M14.8351 4H2.83508V18C2.83508 18.5523 3.2828 19 3.83508 19H13.8351C14.3874 19 14.8351 18.5523 14.8351 18V4Z"
                    stroke="white"
                    strokeWidth="1.62"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M0.835083 4H16.8351"
                    stroke="white"
                    strokeWidth="1.62"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.8351 1H5.83508C5.2828 1 4.83508 1.44772 4.83508 2V4H12.8351V2C12.8351 1.44772 12.3874 1 11.8351 1Z"
                    stroke="white"
                    strokeWidth="1.62"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </div>

    );
}

export default Remove;
